import { CURRENT_VERSION } from '@shared/utils/config/environment';
import { SupportedNetworks, V2Networks } from '@shared/utils/config/networkAddresses';
import { ChainId } from '@shared/utils/config/networks';
// TODO have to make this backwards compatible
export default function getFeesFromQuote({
  quoteData,
  legacyQuoteData
}) {
  try {
    return getFeesFromQuoteNew({
      quoteData
    });
  } catch (_) {
    try {
      return getFeesFromQuoteLegacy({
        quoteData: legacyQuoteData
      });
    } catch (_) {
      return {
        network: '',
        aggregator: '',
        geniusFees: 0,
        gasFees: 0,
        sponsorFees: 0,
        nativeSponsorAmount: 0,
        bridgeFees: 0,
        netNativeSponsorAmount: 0,
        nativeCurrency: '',
        netSponsorFees: 0,
        networkName: ''
      };
    }
    return {
      network: '',
      aggregator: '',
      geniusFees: 0,
      gasFees: 0,
      sponsorFees: 0,
      nativeSponsorAmount: 0,
      bridgeFees: 0,
      netNativeSponsorAmount: 0,
      nativeCurrency: '',
      netSponsorFees: 0,
      networkName: ''
    };
  }
}
export function getFeesFromQuoteNew({
  quoteData
}) {
  var _a;
  if (!quoteData || (quoteData === null || quoteData === void 0 ? void 0 : quoteData.error)) {
    throw new Error('No quote data');
  }
  const quoteDataParsed = (_a = quoteData === null || quoteData === void 0 ? void 0 : quoteData.response) === null || _a === void 0 ? void 0 : _a[0];
  const {
    quote,
    fees
  } = quoteDataParsed;
  if (!quote || !fees) {
    throw new Error('Invalid quote data');
  }
  let network = quote.networkIn || quote.network;
  network = network == ChainId.SOLANA_DLN || network == ChainId.SOLANA_OKX ? ChainId.SOLANA : network;
  let networkOut = quote.networkOut || quote.network;
  networkOut = networkOut == ChainId.SOLANA_DLN || networkOut == ChainId.SOLANA_OKX ? ChainId.SOLANA : networkOut;
  const aggregator = quote.bridge || quote.aggregator;
  const geniusFees = fees.swapFeeUsd;
  const gasFees = fees.gasFeeUsd;
  const sponsorFees = fees === null || fees === void 0 ? void 0 : fees.sponsorUsd;
  const nativeSponsorAmount = fees.sponsorNative;
  const bridgeFees = fees.bridgeFeeUSD;
  const netNativeSponsorAmount = parseFloat(fees.sponsorNative) / 10 ** SupportedNetworks(CURRENT_VERSION)[network].decimals;
  const supportedNetwork = SupportedNetworks(CURRENT_VERSION)[network];
  if (!supportedNetwork) {
    throw new Error('Unsupported network');
  }
  const nativeCurrency = supportedNetwork.nativeCurrency;
  const networkName = supportedNetwork.name;
  const netSponsorFees = fees === null || fees === void 0 ? void 0 : fees.sponsorUsd;
  return {
    network,
    aggregator,
    geniusFees,
    gasFees,
    sponsorFees,
    nativeSponsorAmount: parseFloat(nativeSponsorAmount),
    bridgeFees,
    netNativeSponsorAmount,
    nativeCurrency,
    netSponsorFees,
    networkName,
    networkOut
  };
}
export function getFeesFromQuoteLegacy({
  quoteData
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40;
  const network = ((_c = (_b = (_a = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.quote) === null || _c === void 0 ? void 0 : _c.network) || ((_g = (_f = (_e = (_d = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _d === void 0 ? void 0 : _d.results) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.quote) === null || _g === void 0 ? void 0 : _g.network) || ((_k = (_j = (_h = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _h === void 0 ? void 0 : _h.result) === null || _j === void 0 ? void 0 : _j.price) === null || _k === void 0 ? void 0 : _k.network);
  const nativeDecimals = (_l = V2Networks[network]) === null || _l === void 0 ? void 0 : _l.decimals;
  const nativeCurrency = (_m = V2Networks[network]) === null || _m === void 0 ? void 0 : _m.nativeCurrency;
  const networkName = (_o = V2Networks[network]) === null || _o === void 0 ? void 0 : _o.name;
  const aggregator = ((_p = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _p === void 0 ? void 0 : _p.aggregator) || (quoteData === null || quoteData === void 0 ? void 0 : quoteData.aggregator) || ((_r = (_q = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _q === void 0 ? void 0 : _q.result) === null || _r === void 0 ? void 0 : _r.aggregator) || ((_u = (_t = (_s = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _s === void 0 ? void 0 : _s.results) === null || _t === void 0 ? void 0 : _t[0]) === null || _u === void 0 ? void 0 : _u.aggregator);
  const geniusFees = ((_w = (_v = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _v === void 0 ? void 0 : _v.results) === null || _w === void 0 ? void 0 : _w.length) ? (_y = (_x = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _x === void 0 ? void 0 : _x.results) === null || _y === void 0 ? void 0 : _y.reduce((acc, item) => {
    var _a;
    const swapFees = (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.swapFees;
    return acc + swapFees.swapFeeUsd;
  }, 0) : (_0 = (_z = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _z === void 0 ? void 0 : _z.swapFees) === null || _0 === void 0 ? void 0 : _0.swapFeeUsd;
  const gasFees = ((_2 = (_1 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _1 === void 0 ? void 0 : _1.results) === null || _2 === void 0 ? void 0 : _2.length) ? (_4 = (_3 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _3 === void 0 ? void 0 : _3.results) === null || _4 === void 0 ? void 0 : _4.reduce((acc, item) => {
    var _a;
    const swapFees = (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.swapFees;
    return acc + (swapFees === null || swapFees === void 0 ? void 0 : swapFees.gasFeeUsd);
  }, 0) : (_6 = (_5 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _5 === void 0 ? void 0 : _5.swapFees) === null || _6 === void 0 ? void 0 : _6.gasFeeUsd;
  const sponsorFees = ((_8 = (_7 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _7 === void 0 ? void 0 : _7.results) === null || _8 === void 0 ? void 0 : _8.length) ? (_10 = (_9 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _9 === void 0 ? void 0 : _9.results) === null || _10 === void 0 ? void 0 : _10.reduce((acc, item) => {
    var _a;
    const swapFees = (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.swapFees;
    return acc + swapFees.sponsorFeeUsd;
  }, 0) : (_12 = (_11 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _11 === void 0 ? void 0 : _11.swapFees) === null || _12 === void 0 ? void 0 : _12.sponsorFeeUsd;
  const nativeSponsorAmount = (((_14 = (_13 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _13 === void 0 ? void 0 : _13.results) === null || _14 === void 0 ? void 0 : _14.length) ? (_16 = (_15 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _15 === void 0 ? void 0 : _15.results) === null || _16 === void 0 ? void 0 : _16.reduce((acc, item) => {
    var _a;
    const swapFees = (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.swapFees;
    return acc + parseFloat(swapFees.sponsorNative);
  }, 0) : parseFloat((_18 = (_17 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _17 === void 0 ? void 0 : _17.swapFees) === null || _18 === void 0 ? void 0 : _18.sponsorNative)) / 10 ** nativeDecimals;
  const bridgeFees = ((_20 = (_19 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _19 === void 0 ? void 0 : _19.results) === null || _20 === void 0 ? void 0 : _20.length) ? (_22 = (_21 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _21 === void 0 ? void 0 : _21.results) === null || _22 === void 0 ? void 0 : _22.reduce((acc, item) => {
    var _a;
    const swapFees = (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.swapFees;
    return acc + swapFees.bridgeFeeUSD + ((swapFees === null || swapFees === void 0 ? void 0 : swapFees.dlnMakerFeeUsd) || 0);
  }, 0) : ((_24 = (_23 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _23 === void 0 ? void 0 : _23.swapFees) === null || _24 === void 0 ? void 0 : _24.bridgeFeeUSD) + (((_26 = (_25 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _25 === void 0 ? void 0 : _25.swapFees) === null || _26 === void 0 ? void 0 : _26.dlnMakerFeeUsd) || 0);
  const netNativeSponsorAmount = (((_28 = (_27 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _27 === void 0 ? void 0 : _27.results) === null || _28 === void 0 ? void 0 : _28.length) ? (_30 = (_29 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _29 === void 0 ? void 0 : _29.results) === null || _30 === void 0 ? void 0 : _30.reduce((acc, item) => {
    var _a;
    const swapFees = (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.swapFees;
    return acc + parseFloat(swapFees.netSponsorNative);
  }, 0) : parseFloat((_32 = (_31 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _31 === void 0 ? void 0 : _31.swapFees) === null || _32 === void 0 ? void 0 : _32.netSponsorNative)) / 10 ** nativeDecimals;
  const netSponsorFees = ((_34 = (_33 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _33 === void 0 ? void 0 : _33.results) === null || _34 === void 0 ? void 0 : _34.length) ? (_36 = (_35 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _35 === void 0 ? void 0 : _35.results) === null || _36 === void 0 ? void 0 : _36.reduce((acc, item) => {
    var _a;
    const swapFees = (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.swapFees;
    return acc + parseFloat(swapFees.netSponsorUsd);
  }, 0) : parseFloat((_38 = (_37 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _37 === void 0 ? void 0 : _37.swapFees) === null || _38 === void 0 ? void 0 : _38.netSponsorUsd);
  const useOrchestrator = (_40 = (_39 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.quote) === null || _39 === void 0 ? void 0 : _39.swapFees) === null || _40 === void 0 ? void 0 : _40.useOrchestrator;
  return {
    geniusFees,
    gasFees,
    sponsorFees,
    bridgeFees,
    nativeSponsorAmount,
    nativeCurrency,
    netSponsorFees,
    netNativeSponsorAmount,
    networkName,
    network,
    aggregator,
    useOrchestrator
  };
}